var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatorsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,58.2c6.3,0,11.4-4.8,11.9-11H43.1C43.6,53.3,48.8,58.2,55.1,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.4,43.9c12.5,0,14.8,0,27.2,0c0.9,0,1.7-0.8,1.7-1.7l0,0c0-0.9-0.8-1.7-1.7-1.7h-0.7 c-1.2-4.4-4.5-7.9-8.8-9.2v3c0,0.8-0.6,1.4-1.4,1.4h-1.1v-6.1c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6v6.1h-1.1 c-0.8,0-1.4-0.6-1.4-1.4v-2.9c-4.2,1.4-7.5,4.9-8.7,9.2h-0.8c-0.9,0-1.7,0.8-1.7,1.7l0,0C39.7,43.1,40.5,43.9,41.4,43.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorsDefault);
export default __webpack_public_path__ + "static/media/operators-default.82c1b95843effd586407999976bbb7f9.svg";
export { ForwardRef as ReactComponent };